'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Support old color-adjust prop syntax.
// https://caniuse.com/#search=color-adjust
exports['default'] = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (_prefix2['default'].js === 'Webkit') return _prefix2['default'].css + 'print-' + prop;
    return prop;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/color-adjust.js
// module id = 11
// module chunks = 0